<!--
--- classes abaixo
 ponto_error
 ponto_success
 ponto_atencao
 ponto_disabled
 -->
 <!-- [class.ponto_success]="StatusJornada == 1"
 [class.ponto_atencao]="StatusJornada == 2"
 [class.ponto_error]="StatusJornada == 4" -->
<button
    type="button"
    class="btn_relorio_ponto classes"
    [ngClass]="{
      'ponto_success': StatusJornada() == 1,
      'ponto_in_progress': StatusJornada() == 2,
      'ponto_atencao': (StatusJornada() == 2 && HorarioForaDaJornadaPadrao),
      'ponto_error': StatusJornada() == 4
    }"
    (click)="abrirModal()">
  <!-- {{this.textoBotao}} -->
</button>

<modal-registro-inicio-jornada
></modal-registro-inicio-jornada>

<modal-registro-fim-jornada
></modal-registro-fim-jornada>


